import { useState } from "react";
import { useNavigate } from "react-router-dom";
  function ThreeDotMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setOpen(false);
    navigate("/login");
  };

  return (
    <div style={{ position: "relative" }}>
      {/* THREE DOT BUTTON */}
      <button
        className="btn btn-light"
        onClick={() => setOpen(!open)}
        style={{
          fontSize: "22px",
          border: "none",
          background: "transparent",
            cursor: "hand",
        }}
      >
        ⋮
      </button>

      {/* DROPDOWN */}
      {open && (
        <div
          className="card shadow"
          style={{
            position: "absolute",
            top: "40px",
            left: "0",
            width: "180px",
            zIndex: 999,
          }}
        >
          <ul className="list-group list-group-flush">
            <li className="list-group-item" onClick={() => go("/home")} style={{ cursor: "pointer" }}>
              🏠 Home
            </li>
            <li className="list-group-item" onClick={() => go("/my-items")} style={{ cursor: "pointer" }}>
              📦 My Items
            </li>
             
            <li className="list-group-item" onClick={logout} style={{ cursor: "pointer" }}>
              📝 Log-Out
            </li>
            <li className="list-group-item" onClick={() => go("/login")} style={{ cursor: "pointer" }}>
              🔐 Login
            </li>
             
          </ul>
        </div>
      )}
    </div>
  );
}
export default ThreeDotMenu;

